import type { KitchenBill } from '../choosechow/cartQuote'
import { z } from 'zod'
import { parseTimestamp } from '../../lib/timestamp'

const integer = z.coerce.number().int().nonnegative().safe()
export const campaignSchema = z.object({
  id: z.string().min(1), code: z.string(), name: z.string(),
  discount_bps: integer.min(1).max(10000), min_subtotal_minor: integer, max_discount_minor: integer,
  max_redemptions: integer, redemption_count: integer,
  starts_at: z.string().datetime({ offset: true }), ends_at: z.string().datetime({ offset: true }),
  funded_by: z.enum(['chef', 'platform']),
  is_active: z.boolean(), merchant_profile_id: z.string(), dish_id: z.string(),
})
export type Campaign = z.infer<typeof campaignSchema>
export type CampaignStatus = 'Active' | 'Scheduled' | 'Paused' | 'Expired' | 'Fully redeemed'
export const campaignStatus = (campaign: Campaign, now = Date.now()): CampaignStatus => {
  const endsAt = parseTimestamp(campaign.ends_at) ?? 0
  if (endsAt <= now) return 'Expired'
  if (campaign.max_redemptions > 0 && campaign.redemption_count >= campaign.max_redemptions) return 'Fully redeemed'
  if (!campaign.is_active) return 'Paused'
  const startsAt = parseTimestamp(campaign.starts_at) ?? 0
  if (startsAt > now) return 'Scheduled'
  return 'Active'
}

/** Convert a decimal input into hundredths without floating-point rounding. */
export const hundredths = (input: string): number => {
  if (!/^\d+(?:\.\d{1,2})?$/.test(input.trim())) throw new Error('Use a positive number with at most two decimal places.')
  const [whole, fraction = ''] = input.trim().split('.')
  const value = Number(whole) * 100 + Number(fraction.padEnd(2, '0'))
  if (!Number.isSafeInteger(value)) throw new Error('This amount is too large.')
  return value
}

export interface AppliedPromo { code: string; discountMinor: number; signature: string }
export const promoCartSignature = (bill: KitchenBill): string => JSON.stringify(
  bill.items.map((item) => [item.id, item.item_ref, item.quantity, item.unit_amount_minor]),
)
